import { getOptionValue, namedToOptionDeleted } from 'services/helpers';

import { setDelayAmount } from 'pages/AutomationEngine/helpers';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { tagId, tagOperation, delayAmount } = orgDetails;
  return {
    stepGoal: {
      ...orgDetails,
      delayAmount: setDelayAmount(delayAmount),
      triggers: [
        {
          type: AUTOMATION_STEPS.contact_tag_added_removed.type,
          triggerContactTagAddedRemoved: {
            tagOperation,
            tagId: getOptionValue(tagId),
          },
        },
      ],
    },
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { tag, tagOperation } = firstTrigger.triggerContactTagAddedRemoved;
  let tagId = null;
  if (!tag) {
    addErrorMessage(messageDictionary.thereWasanErrorLoadingTheAssociatedTag);
  } else {
    tagId = namedToOptionDeleted(tag);
  }
  const type = AUTOMATION_STEPS.contact_tag_added_removed_goal.type;

  return { tagId, tagOperation, type };
};

export const contactTagAddedRemovedDTO = {
  forApi,
  forFlow,
};
